import { render, staticRenderFns } from "./NavigationAddressItem.vue?vue&type=template&id=64ee4d22&scoped=true"
import script from "./NavigationAddressItem.vue?vue&type=script&lang=js"
export * from "./NavigationAddressItem.vue?vue&type=script&lang=js"
import style0 from "./NavigationAddressItem.vue?vue&type=style&index=0&id=64ee4d22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ee4d22",
  null
  
)

export default component.exports